/* eslint-disable array-callback-return */
import { Nav } from "../../components/nav"
import SearchIcon from '@material-ui/icons/Search';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import './clientes-page.css'
import { useCallback, useEffect, useState } from "react";
import { useGetListarContatos } from "../../../data/api/listar-contatos/listar-contatos";
import { BaixasStorageKeys, useBaixasStorage } from "../../../services/use-cases/baixas-storage";
import toast from "react-hot-toast";
import { Drawer } from "@material-ui/core";
import { useHistory } from "react-router";
import { ListaContatosModel } from "../../../model/api/ListaContatos/cadastrar-model";
import { CircularLoading } from "../../components/utils/circular-loading";
import { Helmet } from "react-helmet";
import { maskCnpjCpf, maskPhone } from "../../../utils/masks";

export const ClientesPage = () => {

    const { getListarContatos, carregando } = useGetListarContatos()
    const { getRegister } = useBaixasStorage()
    const [pesquisa, setPesquisa] = useState<string>('')
    const [open, setOpen] = useState(false)
    const [usuarios, setUsuarios] = useState<Array<ListaContatosModel>>([])
    const pegarId = getRegister(BaixasStorageKeys.dataRepresentante)
    const history = useHistory()

    const toggleDrawer = () => (
        event: React.KeyboardEvent | React.MouseEvent,
    ) => {
        if (
            event.type === 'keydown' &&
            ((event as React.KeyboardEvent).key === 'Tab' ||
                (event as React.KeyboardEvent).key === 'Shift')
        ) {
            return;
        }

        setOpen(false);
    };

    const gerarMensagemWhatsApp = useCallback((telefone: string) => {
        const mensagem = `Olá, bem vindo à Saurus! Meu nome é ${pegarId.nome} e estou aqui a seu serviço!`
        const link = `https://api.whatsapp.com/send?phone=55${telefone}&text=${mensagem}`
        window.open(link)
    }, [pegarId.nome])

    useEffect(() => {

    })
    const getListaContatos = useCallback(async () => {
        try {
            const res = await getListarContatos(pegarId?.id)
            if (res.erro) {
                throw res.erro
            }
            setUsuarios(res.resultado?.data)
        } catch (e: any) {
            toast.error(e.message)
        }

    }, [getListarContatos, pegarId?.id])

    useEffect(() => {
        getListaContatos()
    }, [gerarMensagemWhatsApp, getListaContatos])
    

    return (
        <>
            <Helmet>
                <title>Lista de Contatos - Saurus AutoCom</title>
            </Helmet>
            <Nav btnLogout />
            <div className="clientesPage">
                <div className="container">
                    <div className="input-group mb-3 mt-3">
                        <span className="input-group-text" id="basic-addon1"><SearchIcon /></span>
                        <input type="text" className="form-control" onChange={e => setPesquisa(e.target.value)} placeholder="Pesquisar" aria-label="Username" aria-describedby="basic-addon1" />
                    </div>
                    {carregando && <CircularLoading tipo="FULLSIZED" />}
                    <div>
                        <button className="btnAdicionarContato" onClick={() => setOpen(!open)}>
                            <AddCircleOutlineIcon className="me-1" />
                            <span>
                                ADICIONAR CONTATO
                            </span>
                        </button>
                    </div>
                    <div className="mt-4">
                        <span className="titleCadastrado">Cadastrados</span>
                    </div>
                    <hr className="hr-colorido" />
                    <div className="row">
                        
                        {usuarios.sort().filter(item => {
                            if (item.nome !== null) {
                                if (pesquisa === '') {
                                    return item
                                } else if (item?.nome.toLowerCase().includes(pesquisa.toLowerCase()) || item?.telefone.includes(pesquisa) || item?.cpfcnpj.includes(pesquisa)) {
                                    return item
                                }
                            }
                        }).map((item, index) => {
                            return (
                                <div className="col-12 col-lg-6" key={index}>
                                    <div className="link-card">
                                        <div className="card mb-3">
                                            <div className="card-body" onClick={() => history.push(`/representante/adicionar-contato/${item.id}|${item.email}|${item.telefone}`)}>
                                                <div className="text-dados-destaque">
                                                    <p className="mb-1">
                                                        {item?.nome}
                                                    </p>
                                                    <p>
                                                        {item?.nomeEmpresa}
                                                    </p>
                                                </div>
                                                <hr />
                                                <p className="text-dados-abaixo">Email: <span>{item?.email}</span></p>
                                                <p className="text-dados-abaixo">CPF/CNPJ: <span>{maskCnpjCpf(item?.cpfcnpj)}</span></p>
                                                <p className="text-dados-abaixo">Tel: <span>{maskPhone(item?.telefone)}</span></p>
                                                <p className="text-dados-abaixo">Observação: <span>{item?.observacao}</span></p>
                                                <p className="text-dados-abaixo">Negociação: <span>{item?.negociacao}</span></p>
                                                <div>
                                                </div>
                                            </div>
                                            {item.telefone.length !== 0 &&
                                                <button className="btn btn-whatsapp" onClick={() => gerarMensagemWhatsApp(item?.telefone)}>
                                                    Chamar WhatsApp
                                                </button>
                                            }
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
                <Drawer anchor={'bottom'} open={open} onClose={toggleDrawer()}>
                    <div className="container mt-4 mb-4">
                        <div className="row">
                            <div className="text-center text-adicionar mb-5">
                                <span>Adicionar Contato</span><br />
                                <span>Selecione a forma de cadastro que desejar</span>
                            </div>
                            <div className="col-12 d-flex justify-content-center">
                                <button className="btn btn-primary mb-3 btn-ler-adicionar" onClick={() => history.push('/representante/scan-qrcode')}>
                                    Ler QRCode
                                </button>
                            </div>
                            <div className="col-12 d-flex justify-content-center">
                                <button className="btn btn-primary btn-ler-adicionar" onClick={() => history.push('/representante/adicionar-contato')}>
                                    Adicionar Contato
                                </button>
                            </div>
                        </div>
                    </div>
                </Drawer>
            </div>
        </>
    )
}